import * as React from 'react';
import ActivityTimeline from './ActivityTimeline';
import { GroupServiceGetResponse } from '../../services/api';
import { fetchGroupRequestHistory } from '../../store/group';
import { useAppDispatch, useAppSelector } from '../../store';
import { APIStatus } from '../../utils/types';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ReactComponent as ClockIcon } from '../../assets/icons/clock-time.svg';
import { flattenTimePeriodDate } from '../../utils/date';


export default function GroupHistory({ group }: { group: GroupServiceGetResponse }) {
  const dispatch = useAppDispatch();
  const { historyApiState, history } = useAppSelector((state) => state.group);

  React.useEffect(() => {
    dispatch(fetchGroupRequestHistory({
      policyNumber: group.policyDetailModel?.policyNumber! as string,
      timePeriodDate: flattenTimePeriodDate(group.policyDetailModel?.timePeriodDate!),
    }));
  }, [group]);

  if (historyApiState === APIStatus.LOADING) {
    return (
      <div className="flex flex-col items-center gap-2 m-10">
        <ProgressSpinner className="w-8 h-8" strokeWidth="4" />
        <p className="text-xs">Fetching history<span className="absolute">...</span></p>
      </div>
    );
  }   
  
  if (!history.length) {
    return (
      <div className="py-4 min-h-[25vh] flex flex-col gap-2 items-center justify-center">
        <ClockIcon className="w-[32px] h-[32px] text-allstate-blue" />
        <h3 className="m-0 text-lg font-medium text-allstate-blue">No history logged yet</h3>
        <p className="m-0">Your requests with an activity timeline will appear here.</p>
      </div>
    );
  }

  return (
    <section className="grid gap-4">
      <div className="mt-4">
        <ActivityTimeline group={group} history={history}  />
      </div>
    </section>
  );
}